import {
  COACHING_NOTES_REQUEST,
  COACHING_NOTES_ERROR,
  COACHING_NOTES_FETCH_SUCCESS,
  TOGGLE_CATEGORY_FORM
} from '../actions/coachingNotes';
import { CATEGORY_FORM_SUCCESS } from '../actions/categoryForm';
import { SET_CATEGORY } from '../actions/category';

export const coachingNotes = (
  state = {
    categories: [],
    formIsVisible: false,
    loading: true,
  },
  action
) => {
  switch (action.type) {
    case COACHING_NOTES_REQUEST: {
      return Object.assign({}, state, { loading: true, error: false });
    }
    case COACHING_NOTES_ERROR: {
      return Object.assign({}, state, { loading: false, error: true });
    }
    case COACHING_NOTES_FETCH_SUCCESS: {
      return Object.assign({}, state, {
        ...action.coachingNotes,
        loading: false,
        error: false,
      });
    }

    case TOGGLE_CATEGORY_FORM: {
      return Object.assign({}, state, { formIsVisible: !state.formIsVisible });
    }
    case CATEGORY_FORM_SUCCESS: {
      return Object.assign({}, state, {
        categories: [action.category, ...state.categories],
      });
    }

    case SET_CATEGORY: {
      const { categoryToUpdate } = action;
      const categories = state.categories.map(c => {
        return c.id === categoryToUpdate.id ? categoryToUpdate : c;
      });
      return Object.assign({}, state, { categories });
    }

    default: {
      return state;
    }
  }
};
